import http from '../common/http';
import env from '../envConfig';
import { getHeader, getHeaderRotasAbertas } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';
import { TipoOrdenacao } from '../model/TipoOrdenacao';

export const obterPostosAtendimentoPeloMunicipio = async (
  numeroIbgeMunicipio: string,
  tipoPosto: string,
  latitude: string,
  longitude: string,
  tipoOrdenacao: string
) => {
  let url = env.urlApi + `/transacional-api/v1/posto-atendimento/municipio/${numeroIbgeMunicipio}`;

  if (tipoPosto && tipoPosto !== 'Todos') {
    url = url + `?tipoPostoAtendimento=${tipoPosto}`;
  }

  if (!tipoOrdenacao || tipoOrdenacao === '') {
    tipoOrdenacao = TipoOrdenacao.DISTANCIA;
  }

  if (latitude && longitude) {
    if (tipoPosto) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url += `latitudeReferencia=${latitude}&longitudeReferencia=${longitude}&tipoOrdenacao=${tipoOrdenacao}`;
  }

  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
